export default "__VITE_ASSET__CpYTBMte__"